import aesReduxConstants from '../constants';
import { selectErrorMessageFromResponse } from '../utils/errorUtil';

const productsReducer = function() {
  const normalizeByKey = function(array, key) {
    const map = {};
    for (let i = 0; i < array.length; i++) map[array[i][key]] = array[i];

    return map;
  };

  const removeKeyFromObject = function(object, key) {
    const keys = Object.keys(object);

    const newObject = {};
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      if (k !== key) newObject[k] = object[k];
    }

    return newObject;
  };

  const __defaultProductsState = {
    clientProductTypes: [],
    allProductTypes: [],

    error: null,
    events: [],
    details: {},

    // productEventIds that are playing sound
    eventsPlayingSound: [],
    eventsPlayedSound: [],

    loading: true,
    severities: [],
  };

  const orderByPriority = function(severities) {
    return angular.copy(severities.sort((a, b) => a.priority > b.priority));
  };

  const reducer = function(state, action) {
    const __constants = aesReduxConstants;
    if (state === undefined) state = __defaultProductsState;

    let delta = {};
    switch (action.type) {
      case __constants.GET_SEVERITY_LIST:
        delta = { severities: orderByPriority(action.severities) };
        break;

      case __constants.GET_PRODUCT_LIST:
        delta = { loading: true };
        break;
      case __constants.GET_PRODUCT_LIST_SUCCESS:
        delta = { loading: false, events: action.products, error: null };
        break;
      case __constants.GET_PRODUCT_LIST_ERROR:
        // clear the events/details array so that there is a state of error and not
        // a half way working thing
        delta = { loading: false, events: [], details: {}, error: selectErrorMessageFromResponse(action.error) };
        break;

      case __constants.UPDATE_PRODUCT_EVENT:
      // update the array with the new event
        var newEvents = [];
        for (var i = 0; i < state.events.length; i++) {
          if (state.events[i].id !== action.event.id) {
            newEvents.push(state.events[i]);
          } else {
            newEvents.push(action.event);
          }
        }

        delta = { loading: false, events: newEvents };
        break;

      case __constants.UPDATE_PRODUCT_DETAILS:
        // update the array with the new details
        var updatedProductDetails = {};
        updatedProductDetails[action.details.productEventId] = action.details;
        delta = { loading: false, details: Object.assign({}, state.details, updatedProductDetails) };
        break;

      case __constants.APPEND_PRODUCT_EVENT:
        delta = { loading: false, events: state.events.concat(action.event) };
        break;
      case __constants.APPEND_PRODUCT_DETAILS:
        var newProductDetails = {};
        newProductDetails[action.details.productEventId] = action.details;

        delta = { loading: false, details: Object.assign({}, state.details, newProductDetails) };
        break;

      case __constants.REMOVE_PRODUCT_EVENT:
        var newEvents = [];
        for (var i = 0; i < state.events.length; i++) {
          if (state.events[i].id !== action.productEventId) {
            newEvents.push(state.events[i]);
          }
        }

        delta = { loading: false, events: newEvents };
        break;

      case __constants.REMOVE_PRODUCT_DETAILS:
        delta = { loading: false, details: removeKeyFromObject(state.details, action.productEventId) };
        break;

      case __constants.GET_PRODUCT_DETAILS_LIST:
        delta = { loading: true };
        break;
      case __constants.GET_PRODUCT_DETAILS_LIST_SUCCESS:
        delta = { loading: false, details: normalizeByKey(action.productDetails, 'productEventId') };
        break;

      case __constants.GET_CLIENTS_AVAILABLE_PRODUCTS_SUCCESS:
        delta = { clientProductTypes: action.products };
        break;

      // get all products even products a client might not have
      case __constants.GET_ALL_PRODUCTS_SUCCESS:
        // normalize it by id to create a look up table
        delta = { allProductTypes: normalizeByKey(action.products, 'id') };
        break;

      case __constants.SET_EVENTS_PLAYING_SOUND:
        delta = { eventsPlayingSound: action.events };
        break;

      case __constants.PRODUCT_EVENT_SOUND_STOPPED:
        var eventsPlayingSound = [];
        for (var i = 0; i < state.eventsPlayingSound.length; i++) {
          if (action.productEventId !== state.eventsPlayingSound[i]) {
            eventsPlayingSound.push(state.eventsPlayingSound[i]);
          }
        }

        if (!action.looped) {
          const eventsPlayedSound = [action.productEventId];
          for (var i = 0; i < state.eventsPlayedSound.length; i++) {
            if (state.eventsPlayedSound[i] !== action.productEventId) {
              eventsPlayedSound.push(state.eventsPlayedSound[i]);
            }
          }
          delta = { eventsPlayingSound, eventsPlayedSound };
        } else {
          delta = { eventsPlayingSound };
        }


        break;

      default:
        return state;
    }

    return Object.assign({}, state, delta);
  };

  return reducer;
};

export default productsReducer();
